export const ADD_RELATIONS = 'ADD_FERPA';
export const DELETE_RELATIONS = 'DELETE_FERPA';